import imgA from "assets/easterAssets/images/A.webp";
import imgB from "assets/easterAssets/images/B.webp";
import imgC from "assets/easterAssets/images/C.webp";
import imgD from "assets/easterAssets/images/D.webp";
import imgE from "assets/easterAssets/images/E.webp";
import imgF from "assets/easterAssets/images/F.webp";
import imgG from "assets/easterAssets/images/G.webp";
import imgH from "assets/easterAssets/images/H.webp";
import imgI from "assets/easterAssets/images/I.webp";
import imgJ from "assets/easterAssets/images/J.webp";
import imgK from "assets/easterAssets/images/K.webp";
import imgL from "assets/easterAssets/images/L.webp";
import imgM from "assets/easterAssets/images/M.webp";
import imgN from "assets/easterAssets/images/N.webp";
import imgO from "assets/easterAssets/images/O.webp";
import imgP from "assets/easterAssets/images/P.webp";
import imgQ from "assets/easterAssets/images/Q.webp";
import imgR from "assets/easterAssets/images/R.webp";
import imgS from "assets/easterAssets/images/S.webp";
import imgT from "assets/easterAssets/images/T.webp";
import imgU from "assets/easterAssets/images/U.webp";
import imgV from "assets/easterAssets/images/V.webp";
import imgW from "assets/easterAssets/images/W.webp";
import imgX from "assets/easterAssets/images/X.webp";
import imgY from "assets/easterAssets/images/Y.webp";
import imgZ from "assets/easterAssets/images/Z.webp";

export default [
  imgA,
  imgB,
  imgC,
  imgD,
  imgE,
  imgF,
  imgG,
  imgH,
  imgI,
  imgJ,
  imgK,
  imgL,
  imgM,
  imgN,
  imgO,
  imgP,
  imgQ,
  imgR,
  imgS,
  imgT,
  imgU,
  imgV,
  imgW,
  imgX,
  imgY,
  imgZ,
];
